/**
 * Spanish About Translations
 * 关于页翻译模块 - 西班牙语
 * 
 * 包含公司介绍、发展历程、使命价值观、认证专利等翻译
 */

import type { AboutTranslations } from '../../types';

export const esAbout: AboutTranslations = {
  title: 'Sobre Nosotros',
  subtitle: 'Innovando comodidad para un futuro sostenible.',
  header: {
    title: 'Sobre JH Heatsup',
    subtitle: 'Innovando comodidad para un futuro sostenible.',
  },
  history: {
    title: 'Nuestra Historia',
    desc: 'Fundada en 2006, Fujian Jinghui Environmental Technology Co., Ltd. (JH Heatsup) comenzó con una visión simple: crear soluciones de calefacción y refrigeración que no solo sean potentes sino también responsables con el medio ambiente. Ubicados en el concurrido Parque de Alta Tecnología de Fuzhou, hemos crecido de un pequeño equipo de I+D a un fabricante global.',
    timelineTitle: 'Hitos de la calefacción infrarroja',
    timelineDesc: 'Seis hitos que muestran nuestra evolución desde las primeras series de infrarrojo lejano hasta soluciones conectadas y de calentamiento rápido para baños.',
    milestones: [
      { year: '2013', title: 'Comienza la producción infrarroja', desc: 'Las series 13A y 13B de calefactores radiantes de infrarrojo lejano entraron en producción.' },
      { year: '2015', title: 'Ampliación de la gama', desc: 'Lanzamos las series de calefactores de infrarrojo lejano 14A/14B y 15A/15B.' },
      { year: '2017', title: 'Calefacción con Bluetooth', desc: 'La serie JH13C llegó al mercado con un altavoz Bluetooth integrado.' },
      { year: '2018', title: 'Soluciones para más espacios', desc: 'Lanzamos calefactores de zócalo e iniciamos la producción de calefactores infrarrojos para baños.' },
      { year: '2019', title: 'Calefacción inteligente con Wi-Fi', desc: 'La serie conectada 13W se lanzó con función Wi-Fi integrada.' },
      { year: '2021', title: 'Calor en el baño en cinco segundos', desc: 'Desarrollamos un calefactor de baño con panel de vidrio capaz de calentarse en solo cinco segundos.' },
    ],
  },
  mission: {
    title: 'Nuestra Misión',
  },
  quality: {
    title: 'Garantía de Calidad',
    desc: 'Procesos certificados ISO9001. Cada calentador se prueba antes de salir de nuestra fábrica.',
  },
  values: {
    title: 'Nuestros Valores Fundamentales',
    sustainability: {
      title: 'Sostenibilidad e Innovación',
      desc: 'Innovando en tecnologías de ahorro energético para reducir la huella de carbono y maximizar la eficiencia térmica.',
    },
    quality: {
      title: 'Calidad Certificada',
      desc: 'Fabricado en instalaciones certificadas ISO9001 y rigurosamente probado para garantizar un rendimiento premium.',
    },
    customerFirst: {
      title: 'Confianza y Sociedad Global',
      desc: 'Confiado por más de 800 socios globales en más de 100 países, construyendo relaciones duraderas mediante un servicio centrado en el cliente.',
    },
  },
  features: {
    title: 'Características del Producto',
    fast: {
      title: 'Calentamiento Rápido',
      desc: 'Calor rápido con tecnología infrarroja eficiente.',
    },
    energy: {
      title: 'Ahorro de Energía',
      desc: 'El control inteligente ayuda a reducir los costos de calefacción.',
    },
    healthy: {
      title: 'Confort Saludable',
      desc: 'Calor radiante sin resecar el aire.',
    },
    safe: {
      title: 'Seguro y Fiable',
      desc: 'Múltiples protecciones de seguridad para tu tranquilidad.',
    },
  },
  companyProfile: {
    title: 'Perfil de la Empresa',
    desc: 'Fujian Jinghui Environmental Technology Co., Ltd. se fundó en 2006 y tiene su sede en Fuzhou (China). Somos una empresa de alta tecnología especializada en la investigación y producción de calefactores de radiación infrarroja lejana. Guiados por la filosofía empresarial de "Buscar la excelencia, crear brillantez juntos", nos comprometemos a ofrecer soluciones de calefacción eficientes, de bajo consumo, saludables y confortables a usuarios de todo el mundo.',
  },
  services: {
    title: 'Servicios Profesionales',
    desc: 'Contamos con ingenieros técnicos profesionales y un equipo comercial con experiencia para ofrecer servicios de alta calidad en aplicaciones industriales y comerciales de calefacción. Aportamos productos de calidad y soluciones sólidas para lograr temperatura confortable, control de humedad y aire fresco en talleres, centros comerciales, gimnasios, cafeterías, invernaderos, espacios exteriores y otros entornos.',
  },
  technology: {
    title: 'Tecnología Líder',
    desc: 'Aplicamos pintura nano-cerámica a los calefactores de radiación infrarroja lejana, resolviendo problemas habituales de decoloración y desprendimiento de pintura en calefactores tradicionales y haciendo la radiación más eficiente y rápida. Nuestra tecnología avanzada de infrarrojo lejano proporciona calentamiento rápido y una distribución uniforme del calor para un ambiente cálido y confortable.',
    nanoCeramic: { title: 'Tecnología Nano-Cerámica', desc: 'Mayor eficiencia de radiación para un calentamiento más rápido' },
    farInfrared: { title: 'Radiación Infrarroja Lejana', desc: 'Distribución uniforme del calor para mayor confort' },
  },
  certifications: {
    title: 'Certificaciones y Patentes',
    desc: 'Hemos obtenido más de 32 patentes de diseño, modelos de utilidad y de invención. Nuestros productos cumplen con estándares internacionales de certificación de seguridad como CCC, ISO9001:2015, CE, CB, SAA, EMC y SASO, lo que garantiza una calidad confiable.',
  },
  clients: {
    title: 'Clientes Globales',
    desc: 'Nuestros productos de calefacción se han exportado a más de 100 países y regiones en todo el mundo, y cuentan con la confianza de usuarios a nivel global.',
    export: 'Exportación a más de 100 países y regiones',
    agents: 'Más de 800 agentes internacionales',
    trusted: 'Confiado por usuarios en todo el mundo',
    showcaseTitle: 'La confianza de socios en todo el mundo',
    showcaseDesc: 'En ferias internacionales nos reunimos cara a cara con distribuidores, compradores de proyectos y profesionales del sector de todo el mundo. Estas conversaciones nos permiten conocer las necesidades locales de calefacción, presentar nuestras últimas soluciones infrarrojas y construir relaciones duraderas con productos fiables, calidad constante y un servicio ágil.',
  },
  manufacturing: {
    title: 'Capacidad de Fabricación',
    desc: 'Disponemos de un taller de producción de 8.000 m² con más de 150 ingenieros técnicos y operarios cualificados, y una capacidad mensual de producción superior a 10.000 unidades. Tenemos la capacidad de completar cada pedido a tiempo, con calidad y en la cantidad requerida.',
    workshopArea: 'Área del taller',
    engineersWorkers: 'Ingenieros y trabajadores',
    monthlyCapacity: 'Capacidad mensual',
    patents: 'Patentes',
  },
  ceo: {
    title: 'Nuestra Fundadora',
    name: 'Sra. Huang Xuefang',
    role: 'Fundadora',
    desc: 'La Sra. Huang Xuefang es una de las primeras investigadoras y diseñadoras de calefactores de infrarrojo lejano en China. En 2003, colaboró con un grupo de socios apasionados por la tecnología de calefacción para desarrollar y diseñar productos evaporativos. En 2006, fundó Fujian Jinghui Environmental Technology Co., Ltd. En 2011, lideró al equipo de I+D para diseñar calefactores de radiación infrarroja lejana tipo panel, integrando de forma ingeniosa controles inteligentes, altavoces Bluetooth y Wi‑Fi en los calefactores, convirtiéndolos no solo en dispositivos de calefacción, sino también en un estilo de vida. Cada detalle de diseño refleja su fusión de la estética occidental con el encanto oriental, dotando a los productos de una vitalidad única.',
    quote: '"Estamos comprometidos a crear un mundo más verde y cálido a través de la tecnología."',
  },
  applications: {
    title: 'Escenarios de Aplicación',
    desc: 'Nuestros calentadores de infrarrojo lejano se utilizan ampliamente en varios escenarios, proporcionando soluciones de calefacción completas para usted',
    restaurant: {
      title: 'Restaurante',
      desc: '',
      icon: 'Utensils',
    },
    livingRoom: {
      title: 'Sala de Estar',
      desc: '',
      icon: 'Sofa',
    },
    office: {
      title: 'Oficina',
      desc: '',
      icon: 'Building',
    },
    patio: {
      title: 'Terraza',
      desc: '',
      icon: 'Sun',
    },
    sauna: {
      title: 'Sala de Sauna',
      desc: '',
      icon: 'Flame',
    },
    garage: {
      title: 'Garaje',
      desc: '',
      icon: 'Warehouse',
    },
    balcony: {
      title: 'Gimnasio',
      desc: '',
      icon: 'Dumbbell',
    },
    entertainment: {
      title: 'Sala de Entretenimiento',
      desc: '',
      icon: 'Gamepad2',
    },
  },
};
